import { api } from "../api";

export type IntegratorUserCompanyPayload = {
  clientId: number;
  companyRole?: "OWNER" | "MEMBER" | string;
  status?: "ACTIVE" | "INACTIVE" | string;
  isDefault?: boolean;
};

export type IntegratorUserPayload = {
  name: string;
  email: string;
  phone?: string | null;
  globalRole: "INTEGRATOR_MANAGER" | "INTEGRATOR_USER" | string;
  status?: "INVITED" | "ACTIVE" | "INACTIVE" | "BLOCKED" | string;
  companies: IntegratorUserCompanyPayload[];
};

export const getIntegratorUsers = async () => {
  return await api.get("/admin/integrator-users");
};

export const createIntegratorUser = async (payload: IntegratorUserPayload) => {
  return await api.post("/admin/integrator-users", payload);
};

export const updateIntegratorUser = async (userId: number, payload: IntegratorUserPayload) => {
  return await api.put(`/admin/integrator-users/${userId}`, payload);
};

export const sendIntegratorPasswordLink = async (userId: number) => {
  return await api.post(`/admin/integrator-users/${userId}/send-password-link`);
};

export const deactivateIntegratorUser = async (userId: number) => {
  return await api.delete(`/admin/integrator-users/${userId}`);
};